import { resolveCoreMessage } from "@plaatplan/i18n";
import { useLocale } from "../i18n/useLocale.js";

export function BoardAccessibleSummary({ sheet, id }) {
  const { display } = useLocale();
  const unusedMessage = resolveCoreMessage(display, sheet.unusedMessage);

  if (sheet.unused) {
    return (
      <section
        className="board-sr-summary"
        id={id}
        aria-label={display.t("web.a11y.unusedSummary")}
      >
        <p>{unusedMessage}</p>
      </section>
    );
  }

  if (!sheet.placements.length) return null;

  const formatPanel = (placement) => {
    const size = `${display.formatPanelSize(placement.originalLength, placement.originalWidth)} × ${display.formatThickness(placement.thickness)}`;
    const position = display.formatPanelSize(Math.round(placement.x), Math.round(placement.y));
    return `${placement.projectName}, ${placement.name}: ${size}${placement.rotated ? display.t("web.a11y.rotated") : ""}${display.t("web.a11y.position", { position })}`;
  };

  return (
    <section
      className="board-sr-summary"
      id={id}
      aria-label={display.t("web.a11y.sheetSummary", { number: sheet.index + 1 })}
    >
      <h3 className="sr-only">
        {display.t("web.a11y.panelsOnSheet", { number: sheet.index + 1 })}
      </h3>
      <ol>
        {sheet.placements.map((placement) => (
          <li key={`${placement.panelId}-${placement.occurrence}`}>
            {formatPanel(placement)}
          </li>
        ))}
      </ol>
    </section>
  );
}
